import { formatHumanName } from '@medplum/core'
import { useActivePractitioner } from '@/pages/Schedule/context/'
import { PractitionerMultiSelect } from './PractitionerMultiselect'
import { PractitionerWithColor, DOCTOR_COLORS } from './types'

export const ListOfSelectedPractitioners = ({
  practitionerOptions,
}: {
  practitionerOptions: PractitionerWithColor[]
}) => {
  const {
    selectedMultiplePractitionerIds: selectedPractitioners,
    handleSetSelectedMultiplePractitionerIds: setSelectedPractitioners,
  } = useActivePractitioner()

  const removePractitioner = (practitionerId: string) => {
    setSelectedPractitioners(selectedPractitioners.filter((id) => id !== practitionerId))
  }

  const selectAll = () => {
    setSelectedPractitioners(practitionerOptions.map((practitioner) => practitioner.id as string))
  }

  const clearSelection = () => {
    setSelectedPractitioners([])
  }

  return (
    <div className="mt-4 flex items-start gap-3 rounded-xl border border-[#EAECEF] bg-[#F7F8FA] py-2 pr-2 pl-3.5">
      <div className="flex h-[34px] shrink-0 items-center">
        <PractitionerMultiSelect practitionerOptions={practitionerOptions} />
      </div>

      <div className="flex min-h-[34px] min-w-0 flex-1 flex-wrap items-center gap-2 py-0.5">
        {selectedPractitioners.length === 0 ? (
          <p className="text-[13px] text-[#9AA0A8]">Select practitioners to view their schedules</p>
        ) : (
          selectedPractitioners.map((id) => {
            const practitioner = practitionerOptions.find((item) => item.id === id)
            if (!practitioner) return null
            const color = practitioner.color || DOCTOR_COLORS[0]
            const name = practitioner.name?.[0] ? formatHumanName(practitioner.name[0]) : ''
            return (
              <span
                key={`selected-${id}`}
                className="inline-flex shrink-0 items-center gap-2 rounded-full px-[13px] py-[7px] text-[13.5px] leading-none font-bold whitespace-nowrap text-[#2A2F36]"
                style={{ background: `${color}1A`, border: `1px solid ${color}33` }}
              >
                <span className="h-[9px] w-[9px] rounded-full" style={{ background: color }} />
                <span className="whitespace-nowrap">{name}</span>
                <button
                  type="button"
                  title="Remove doctor"
                  aria-label={`Remove ${name}`}
                  onClick={() => removePractitioner(id)}
                  className="ml-px cursor-pointer rounded-full border-none bg-transparent p-0.5 text-[11px] leading-none text-[#8A8F98] opacity-90 hover:opacity-100"
                >
                  ✕
                </button>
              </span>
            )
          })
        )}
      </div>

      <div className="schedule-v2-mulish flex h-[34px] shrink-0 items-center gap-0.5 border-l border-[#E4E7EB] pl-2">
        <button
          type="button"
          onClick={selectAll}
          className="schedule-v2-mulish inline-flex shrink-0 cursor-pointer items-center rounded-md border-none bg-transparent px-2.5 py-[3px] !text-[14px] !font-bold text-[#E5533D] transition hover:bg-[#FDECE8]"
        >
          Select all
        </button>
        {selectedPractitioners.length > 0 && (
          <button
            type="button"
            onClick={clearSelection}
            className="schedule-v2-mulish inline-flex shrink-0 cursor-pointer items-center rounded-md border-none bg-transparent px-2.5 py-[3px] !text-[14px] !font-bold whitespace-nowrap text-[#6B7280] transition hover:bg-[#EEF0F2]"
          >
            Clear selection
          </button>
        )}
      </div>
    </div>
  )
}
